'use client'

import { useContext } from 'react'
import { Spacer } from '@vinted/web-ui'

import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'
import { EscrowFeesContext } from '@marketplace-web/item-page/item-page-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import ItemPageDiscountBadges from '../ItemPageDiscountBadges'
import { getPriceBreakdownPhotoThumbnail } from '../../utils/item-page'
import { ItemPageDiscountBadgesPluginModel } from './types'

type Props = {
  data: ItemPageDiscountBadgesPluginModel
}

const ItemPageDiscountBadgesPlugin = ({ data }: Props) => {
  const discountBadgePlacementTestIsOn = useAbTest('discount_badge_placement_v1')?.variant === 'on'
  const { itemTitle, itemId, isSellerBusiness, itemUserId, photos, itemPrice } = data

  const transformedItemPrice = transformCurrencyAmountDto(itemPrice)
  const itemPhotoSrc = getPriceBreakdownPhotoThumbnail(photos)
  const { escrowFees } = useContext(EscrowFeesContext)

  if (!escrowFees || !discountBadgePlacementTestIsOn) return null

  return (
    <ItemPageDiscountBadges
      escrowFees={escrowFees}
      isSellerBusiness={isSellerBusiness}
      itemUserId={itemUserId}
      itemTitle={itemTitle}
      itemPhotoSrc={itemPhotoSrc}
      itemPrice={transformedItemPrice}
      itemId={itemId}
      bottomSpacer={<Spacer size={Spacer.Size.Large} />}
    />
  )
}

export default ItemPageDiscountBadgesPlugin
